$(function ($) {
    "use strict";

    $('[showmore]').each(function () {
        var $module = $(this);

        var $btn = $module.find('[showmore-btn]');

        var $container = $module.find('[showmore-items]');
        var maxCount = +$btn.attr('showmore-btn') || 4;

        $btn.click(function () {
            var count = 0;
            var all = $container.children();
            all.each(function () {
                var e = $(this);
                if (!e.is(":visible")) {
                    if (count <= maxCount || maxCount <= count) {
                        e.show();
                    }
                    count++;
                }
            });

            if ($container.find(">:visible").length === all.length) {
                $btn.hide();
            }
        });

    });
});           

